var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_155_4",
    "data-name": "Component 155 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.001,
    height: 84.001,
    viewBox: "0 0 84.001 84.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M-1320-8276a41.725,41.725,0,0,1-16.347-3.3,41.857,41.857,0,0,1-13.35-9,41.871,41.871,0,0,1-9-13.352A41.74,41.74,0,0,1-1362-8318a41.731,41.731,0,0,1,3.3-16.347,41.854,41.854,0,0,1,9-13.351,41.857,41.857,0,0,1,13.35-9A41.725,41.725,0,0,1-1320-8360a41.732,41.732,0,0,1,16.349,3.3,41.858,41.858,0,0,1,13.351,9,41.855,41.855,0,0,1,9,13.351A41.728,41.728,0,0,1-1278-8318a41.738,41.738,0,0,1-3.3,16.349,41.874,41.874,0,0,1-9,13.352,41.858,41.858,0,0,1-13.351,9A41.732,41.732,0,0,1-1320-8276Zm-7-54h0v25l22-12.5-22-12.5Z",
    transform: "translate(1362 8360)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-1320-8276a41.725,41.725,0,0,1-16.348-3.3,41.856,41.856,0,0,1-13.35-9,41.872,41.872,0,0,1-9-13.352A41.74,41.74,0,0,1-1362-8318a41.73,41.73,0,0,1,3.3-16.347,41.854,41.854,0,0,1,9-13.351,41.856,41.856,0,0,1,13.35-9A41.725,41.725,0,0,1-1320-8360a41.731,41.731,0,0,1,16.349,3.3,41.854,41.854,0,0,1,13.351,9,41.855,41.855,0,0,1,9,13.351A41.73,41.73,0,0,1-1278-8318a41.74,41.74,0,0,1-3.3,16.349,41.873,41.873,0,0,1-9,13.352,41.854,41.854,0,0,1-13.351,9A41.731,41.731,0,0,1-1320-8276Zm-7-54h0v25l22-12.5-22-12.5Z",
    transform: "translate(1362 8360)",
    fill: "#2b3382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.32dd5f3642f9c031010adc07a916beec.svg";
export { ForwardRef as ReactComponent };